import type { X402LinkedIdentity } from "../../lib/x402Profile";

export function X402LinkedIdentityNotice({
  identities,
  unavailable = false,
}: {
  identities: X402LinkedIdentity[];
  unavailable?: boolean;
}) {
  if (identities.length === 0 && !unavailable) return null;

  return (
    <div className="mt-5 border border-faint rounded-sm bg-paper p-4 max-w-2xl">
      <p className="btn-mono text-[10px] uppercase tracking-[0.14em] text-olive-deep">
        Existing Boon identity links
      </p>
      {identities.length > 0 && (
        <p className="mt-2 text-sm text-ink leading-relaxed">
          Already connected in Boon: {formatIdentityList(identities)}. Opening this x402 profile does not reconnect or change those identities.
        </p>
      )}
      {unavailable && (
        <p className="mt-2 text-sm text-muted leading-relaxed">
          Boon could not check existing identity links. You can continue, but verify the connected address before signing.
        </p>
      )}
    </div>
  );
}

function formatIdentityList(identities: X402LinkedIdentity[]): string {
  const labels = identities.map(identityLabel);
  if (labels.length === 1) return labels[0]!;
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(", ")}, and ${labels.at(-1)}`;
}

function identityLabel(identity: X402LinkedIdentity): string {
  if (identity.provider === "github") return identity.handle.replace(/^github:/, "GitHub @");
  if (identity.provider === "x") return identity.handle.replace(/^x:/, "X @");
  return identity.handle.replace(/^agent:/, "ERC-8004 agent ");
}
